/**
 * services 域名接口配置
 * urlPrefix 接口前缀
 */
let env = localStorage.getItem('envValue');

let urlPrefix = '/inner';
switch (document.location.hostname) {
    case 'tgl.qq.com':
        urlPrefix = `${document.location.protocol}//api.tgl.qq.com${urlPrefix}`;
        break;
    default:
        urlPrefix = `${document.location.protocol}//api.tgl.qq.com${urlPrefix}`;
}
let uploadUrlPrefix = '';
switch (document.location.hostname) {
    case 'tgl.qq.com':
        uploadUrlPrefix = `${document.location.protocol}//apps.tgl.qq.com`;
        break;
    case 'pre.tgl.qq.com':
    case 'test.tgl.qq.com':
        uploadUrlPrefix = `${document.location.protocol}//apps.tgl.qq.com`;
        break;
    default:
        uploadUrlPrefix = `${document.location.protocol}//apps.tgl.qq.com`;
}
let notifyAuthUrl = `${document.location.protocol}//${location.host}/activity/#/account/notify/{result}`;
if (location.hostname == 'test.tgl.qq.com') {
    notifyAuthUrl = `${document.location.protocol}//${location.host}/#/account/notify/{result}`;
}

let openUrl = '';
switch (document.location.hostname) {
    case 'test.doujin.qq.com':
        openUrl = `${document.location.protocol}//test.doujin.qq.com/openpre/inner`;
        break;
    default:
        openUrl = `${document.location.protocol}//api.tgl.qq.com/inner`;
}

let activityUrl = '/activity/player_horizon.shtml';

let tglPrefix = `${document.location.protocol}//api.tgl.qq.com`;

// 对测试环境接口做处理
if (env && env.includes('test')) {
    urlPrefix = urlPrefix.replace('api.tgl.qq.com', 'tapi.tgl.qq.com');
    openUrl = openUrl.replace('api.tgl.qq.com', 'tapi.tgl.qq.com');
    tglPrefix = tglPrefix.replace('api.tgl.qq.com', 'tapi.tgl.qq.com');
}

export {
    urlPrefix,
    uploadUrlPrefix,
    activityUrl,
    notifyAuthUrl,
    openUrl,
    tglPrefix,
};
